import { render, staticRenderFns } from "./CmgIngredients.vue?vue&type=template&id=1c423fc6&scoped=true&lang=pug"
import script from "./cmg-ingredients.ts?vue&type=script&lang=ts&external"
export * from "./cmg-ingredients.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgIngredients.vue?vue&type=style&index=0&id=1c423fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c423fc6",
  null
  
)

export default component.exports